import React, { useEffect, useState } from 'react'
import FormInputs from '../../../../components/UI/FormInputs'
import Buttons from '../../../../components/UI/Buttons'
import WithRoutify from '../../../../hoc/WithRoutify'
import EmrVisitsService from '../../../../services/EmrVisitsService'
import EmrConfigService from '../../../../services/EmrConfigService'
import TableGrid from '../../../../components/UI/TableGrid'
import { toQueryString, getCss, capitalizeName } from '../../../../utils/commonUtils'
import { OK } from '../../../../utils/constant'
import Alert from '../../../../components/UI/ConfirmBox/Alert'
import { OnTabKeyPress } from '../../../../utils/cssUtils'


const VitalsTab = (props) => {
    const{visit_id,VISITCATEGORY,
        isChartingSectionDirty,
        setIsChartingSectionDirty,
        showUnsavedAlert,
        setShowUnsavedAlert,
        pendingCallback,
        setPendingCallback
    }=props
    const tableHeaders=  [
    //   {
    //     label: "Visit Type ",
    //     key: "Visit_Type",
    //     type: "",
    //     inputType: "TextInput",
    //   },
       {
           label: "Visit Date ",
           key: "date",
           type: "",
           inputType: "TextInput",
           sortName:'date'
      },
        {
        label: "Height (in)",
        key: "height",
        type: "",
        inputType: "TextInput",
      },
        {
        label: "Weight",
        key: "weight",
        type: "",
        inputType: "TextInput",
      },
        {
        label: "BMI",
        key: "bmi",
        type: "",
        inputType: "TextInput",
      },
        {
        label: "Heart Rate",
        key: "heart_rate",
        type: "",
        inputType: "TextInput",
      },
        {
        label: "Respiratory",
        key: "respiratory",
        type: "",
        inputType: "TextInput",
      },
        {
        label: "Oxygen Saturation",
        key: "saturation",
        type: "",
        inputType: "TextInput",
      },
        {
        label: "Temperature",
        key: "temperature",
        type: "",
        inputType: "TextInput",
      },
        {
        label: "Pain scale",
        key: "pain_scale",
        type: "",
        inputType: "TextInput",
      },
        {
        label: "Blood Pressure",
        key: "blood_pressure",
        type: "",
        inputType: "TextInput",
      },
        {
        label: "Action",
        key: "action",
        type: "Actions",
      },
    
    
    ]
    const [formdata, setFormdata] = React.useState({})
    const [tableRecords,setTableRecords]=useState({
        tableHeaders: tableHeaders,
        tableRows: {
          data: [],
          status: 1000,
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "date",
          sort_order: "asc",
          search: {},
        },
    })
    
    const calculateBloodPressureStatus = (systolic, diastolic) => {
        const sys = systolic === '' || systolic === null || systolic === undefined ? '' : Number(systolic);
        const dia = diastolic === '' || diastolic === null || diastolic === undefined ? '' : Number(diastolic);
        
        if (sys === '' && dia === '') {
            return 'Not Started';
        } else if (sys === '' || dia === '') {
            return 'Pending';
        } else if ((sys < 0 || sys > 139) || (dia < 0 || dia > 89)) {
            return 'Abnormal';
        } else {
            return 'Normal';
        }
    };

    // BMI from height (feet + inches) and weight in pounds
    const calculateBMI = (feet, inches, weightPounds) => {
        const heightInFeet = feet != null && feet !== '' ? Number(feet) : 0;
        const heightInInch = inches != null && inches !== '' ? Number(inches) : 0;
        const weightInPounds = weightPounds != null && weightPounds !== '' ? Number(weightPounds) : 0;
        const heightInches = heightInFeet * 12 + heightInInch;
        if (heightInches <= 0 || weightInPounds <= 0) return null;
        const bmi = (weightInPounds / (heightInches * heightInches)) * 703;
        return Math.round(bmi * 10) / 10;
    };
    
    useEffect(()=>{
        fetchVitalsList()
        fetchHistory()
    },[])

    // Refresh vitals data when refreshEmrTrigger changes (from Start Over)
    useEffect(() => {
        if (props.refreshEmrTrigger !== undefined && props.refreshEmrTrigger > 0) {
            fetchVitalsList();
            fetchHistory();
        }
    }, [props.refreshEmrTrigger]);
    const fetchHistory=async(query={})=>{
         try{    
            props.Loader(true)
            const queryString = toQueryString({ ...tableRecords.pagination, ...query });
            const response=await EmrVisitsService.getVitalsHistory(visit_id,queryString)
            console.log("respone",response);
            
            if(response){
                let tableData = []
                tableData=response.data.data.map((item, index) => {
                    const feet = item.height_feet != null && item.height_feet !== '' ? Number(item.height_feet) : 0;
                    const inches = item.height_inch != null && item.height_inch !== '' ? Number(item.height_inch) : 0;
                    const totalInches = feet * 12 + inches;
                    const heightDisplay = totalInches > 0 ? `${(Math.round(totalInches * 10) / 10).toFixed(1)}` : '';
                    const bmi = calculateBMI(item.height_feet, item.height_inch, item.weight);
                    return {
                        rowId: index + 1,
                        data: {
                            Visit_Type: VISITCATEGORY,
                            date:item.visit_date,
                            height:heightDisplay,
                            weight:item.weight,
                            bmi: bmi != null ? String(bmi) : '',
                            heart_rate: item.heart_rate,
                            respiratory: item.respiration,
                            saturation:item.saturation,
                            temperature: item.temperature,
                            pain_scale: item.pain_scale,
                            blood_pressure:`${item.left_bp},${item.right_bp}`,
                            action: [{
                                className: 'btn btn-icon btn-transparent-dark',
                                iconType: 'Remove',
                                acl: 'any',
                                title: 'Delete',
                                isDelete: true,
                                clickHandler: () => handleDeleteHistory(item.vital_history_id),
                            }]
                        }
                    }
                })
                setTableRecords((prev)=>{
                    return {
                        ...prev,
                        tableRows:{
                            data:tableData,
                            status:200
                        },
                        pagination: {
                            ...prev.pagination,
                            ...query,
                            totalRecords: response.data.total,
                        },
                    }
                })
            }
             props.Loader(false)

        }catch(err){
             props.Loader(false)
             props.Toast.error('Something went wrong')
        }
    }
    const fetchVitalsList=async()=>{
        try{    
            props.Loader(true)
            const response=await EmrVisitsService.getVitalsList(visit_id)
            if(response){
                const data = {...response};
                // Calculate blood pressure status if not present or if BP values changed
                if (data.left_bp !== undefined || data.right_bp !== undefined) {
                    data.blood_pressure_result = calculateBloodPressureStatus(data.left_bp, data.right_bp);
                }
                setFormdata(data)
            }
             props.Loader(false)

        }catch(err){
              props.Loader(false)
            props.Toast.error('Something went wrong')
        }
    }
    const weightsAndHeights = [
         {
           label: 'Height', 
           type: "Decimal",
           placeholder: 'Feet',
           className: 'form-control form-control-solid',
           name: 'height_feet',
        }, 
        {
           label: "", 
           type: "Decimal",
           placeholder: 'Inches',
           className: 'form-control form-control-solid',
           name: 'height_inch',
        },
        {
           label: 'Weight(In Pounds)', 
           type: "Decimal",
           placeholder: 'Pounds',
           className: 'form-control form-control-solid',
           name: 'weight',
        },
        {
           label: 'BMI',
           type: "Decimal",
           placeholder: 'BMI',
           className: 'form-control form-control-solid bg-light',
           name: 'bmi_display',
           readOnly: true,
        }

    ]
    const vitals = [
        {
          label:'Pain scale',
          type: "Number",
          placeholder: 'Content',
          range:'0 - 10',
          min_value:0,
          max_value:10,
          name:'pain_scale',
          className:'form-control',
        },
         {
          label:'Heart Rate',
          type: "Decimal",
          placeholder: 'Content',
          range:'60 - 100 bpm',
          min_value:60,
          max_value:100,
          name:'heart_rate',
          className:'form-control',
        },
         {
          label:'Respiratory',
          type: "Number",
          placeholder: 'Content',
          range:'12 - 20 breaths/min',
          min_value:12,
          max_value:20,
          name:'respiration',
          className:'form-control',
        },
         {
          label:'Oxygen Saturation ',
          type: "Number",
          placeholder: 'Content',
          range:'95 - 100 %',
          min_value:95,
          max_value:100,
          name:'saturation',
          className:'form-control',
        },
         {
          label:'Temperature',
          type: "Decimal",
          placeholder: 'Content',
          range:'97 - 99 °F',
          min_value:97,
          max_value:99,
          name:'temperature',
          className:'form-control',
        },
    ]
    const bloodPressures = [
        {
          label:'Systolic',
          type: "Number",
          placeholder: 'Content',
          range:'0 - 139 mmHg',
          min_value:0,
          max_value:139,
          rangeMax:139,
          name:'left_bp',
          id:'left_bp',
          className:'form-control',
          onKeyPress:(event)=>OnTabKeyPress(event,"right_bp",""),
        },
        {
          label:'Diastolic',
          type: "Number",
          placeholder: 'Content',
          range:'0 - 89 mmHg',
          min_value:0,
          max_value:89,
          rangeMax:89,
          name:'right_bp',
          id:'right_bp',
          className:'form-control',
          onKeyPress:(event)=>OnTabKeyPress(event,"","left_bp"),
        },
    ]
    const Historyfromothervisits = [{},{},{},{},{}].map((item, index) => {
        return{
            rowId:index+1,
            data: {
                Visit_Type: 'Work Comp',
                Height: "5'10\"",
                Weight: 143.3,
                Heart_Rate: 64,
                Respiratory: 15,
                Oxizen_Satuaration: 96,
                Temparature: 98,
                Pain_scale: 2,
                Blood_Pressure: '122,124',
                 }
    }
    })
    const handleChange = (val,name) => {
        if (setIsChartingSectionDirty) {
                setIsChartingSectionDirty(true);
            }
            setFormdata((prev) => {
                const updated = {
                    ...prev,
                    [name]: val
                };
                // Auto-calculate blood pressure status when systolic or diastolic changes
                if (name === 'left_bp' || name === 'right_bp') {
                    updated.blood_pressure_result = calculateBloodPressureStatus(
                        name === 'left_bp' ? val : updated.left_bp,
                        name === 'right_bp' ? val : updated.right_bp
                    );
                }
                return updated;
            })
    }
    const getValidationClass = (val, min, max) => {
        const num = Number(val);
        return num !== "" && (num < min || num > max)
            ? "cal_text-red font-weight-bold"
            : "";
    };
    // --- ADDED: Alert handler functions ---
    const handleProceed = () => {
        if(setIsChartingSectionDirty) setIsChartingSectionDirty(false);
        if(setShowUnsavedAlert) setShowUnsavedAlert(false);
        if (pendingCallback) pendingCallback();
        if(setPendingCallback) setPendingCallback(null);
    };
    
    const handleCancel = () => {
        if(setShowUnsavedAlert) setShowUnsavedAlert(false);
        if(setPendingCallback) setPendingCallback(null);
    };
    const handleSubmit = async() => {
        try{
            props.Loader(true)
            const payload={
                ...formdata
            }
            let result=null
            if(formdata.vital_id){
             result= await EmrVisitsService.updateVitals(visit_id,formdata.vital_id,payload)
            }else{
             result=await EmrVisitsService.saveVitals(visit_id,payload)
            }
            
            if (result.code === 200) {
                setFormdata({})
                fetchVitalsList()
                fetchHistory()
                props.SetFinishedTabs((prev) => (Array.from(new Set([...prev, props.selectedTab]))))
                props.SetFinishedSubTabs((prev) => (Array.from(new Set([...prev, props.selectedSubTab]))))
                handleTick(Array.from(new Set([...props.finishedTabs, props.selectedTab])), Array.from(new Set([...props.finishedSubTabs, props.selectedSubTab])))
                props.Toast.success(formdata.vital_id ? "Data updated successfully" : 'Data added successfully')
                if(setIsChartingSectionDirty) setIsChartingSectionDirty(false); // Reset flag
                return true; // Return success
            }
        }catch(err){
            console.log(err)
             props.Toast.error('something went wrong!')
             return false;
        }   
        finally{
              props.Loader(false)
        }
    }
    const handleTick=async(maintabs,subtabs)=>{
          try{
            
            const payload = props.tabData.map((tab) => ({
              ...tab,
              tab_status: maintabs.includes(tab.tab_name) ? "COMPLETED" : "NOT STARTED",
              [tab.tab_name]: tab[tab.tab_name]?.map((subtab) => ({
                ...subtab,
                sub_tab_status: subtabs.includes(subtab.apikey)
                  ? "COMPLETED"
                  : "NOT STARTED",
              })) || [],
            }));
            const response = await EmrConfigService.setTabsListstatus(props.visit_id,payload,props.VISITCATEGORY)
            if(response){
              props.fetchTabsList()
            }
          }catch(err){
      
          }finally{
      
          }
        }
    const handleIncomplete = () => {
        if(setIsChartingSectionDirty) setIsChartingSectionDirty(false);
        props.SetFinishedTabs((prev) => prev.filter(tab => tab !== props.selectedTab))
        props.SetFinishedSubTabs((prev) => prev.filter(subtab => subtab !== props.selectedSubTab))
        handleTick(
          props.finishedTabs.filter(tab => tab !== props.selectedTab), 
          props.finishedSubTabs.filter(subtab => subtab !== props.selectedSubTab)
        )
    }
    const ClearHandler=async()=>{
        try {
            const payload = {
                ...formdata,
                'height_inch': "",
                'height_feet': "",
                'weight': "",
                'pain_scale': "",
                'heart_rate': "",
                'respiration': "",
                'saturation': "",
                'temperature': "",
                'left_bp': "",
                'right_bp': "",
            }
            setFormdata({})
            
            // Remove tick from Vitals tab when data is cleared
            handleIncomplete();
            
            props.Toast.success("Data cleared successfully")
            if(setIsChartingSectionDirty) {
                setIsChartingSectionDirty(false);
            }
            // if (formdata.vital_id) {
            //     const result = await EmrVisitsService.updateVitals(visit_id, formdata.vital_id, payload)

            //     if (result.code === 200) {
                    
            //         // fetchVitalsList()
            //         
            //     }
            // }
        } catch (err) {
               console.log(err)
             props.Toast.error('something went wrong!')
        }
    }
    const handleDeleteHistory = async (vitalHistoryId) => {
        if (!vitalHistoryId) {
            props.Toast.error('No history record to delete');
            return;
        }
        
        try {
            props.Loader(true);
            const result = await EmrVisitsService.deleteVitalHistory(visit_id, vitalHistoryId);
            
            if (result && (result.code === 200 || result.code === OK)) {
                fetchHistory(); // Refresh the history table
                props.Toast.success('Vital history deleted successfully');
            } else {
                props.Toast.error(result?.data?.message || 'Failed to delete vital history');
            }
        } catch (err) {
            console.log(err);
            props.Toast.error('Something went wrong while deleting vital history!');
        } finally {
            props.Loader(false);
        }
    }

  return (
    <div className='row'>
        <div className='col-12'>
              <div className='card sh_basecard border-0 shadow-none h-auto'>
                  <div className='card-header p-2 sh_basecardHeader'>
                      <div className='d-flex w-100 justify-content-between align-items-center '>
                          Body Height and Weight
                          <div class="d-flex">
                          {formdata['vital_id'] && (
                              <Buttons
                                  clickHandler={() => ClearHandler()}
                                  className="btn  sh_btnlight p3-light mr-2"
                                  acl={'any'}
                                  isDelete={true}
                                  label={"Clear All"} />
                          )}
                          <Buttons className="btn btn-primary sh_btnprimary"
                              title={"Accept"}
                              acl={'any'}
                              clickHandler={() => { handleSubmit(); }}
                          >Accept</Buttons>
                          </div>
                      </div>
                   
                  </div>
                  <div className='card-body p-2 sh_basecardBody'>
                      <div className='row'>
                          {weightsAndHeights.map((item, index) => (
                              <div class="col-3" key={index}>
                                  <div class="form-group">
                                      <label class="mb-0 text-sm opacity-75 text-truncate" for="">{item.label!==''?item.label:'\u00A0'}</label>
                                      <FormInputs {...item} value={item.name === 'bmi_display' ? (calculateBMI(formdata.height_feet, formdata.height_inch, formdata.weight) ?? '') : formdata[item.name]} changeHandler={item.name === 'bmi_display' ? () => {} : (val) => {handleChange(val,item.name) }} />
                                  </div>
                              </div>
                          ))}
                      </div>
                  </div>
              </div>
              <div className='card sh_basecard border-0 shadow-none h-auto'>
                  <div className='card-header p-2 sh_basecardHeader'>
                      <div className='d-flex w-100 justify-content-between align-items-center '>
                          Vitals
                      </div>
                  </div>
                  <div className='card-body p-2 sh_basecardBody'>
                      <div className='row'>
                          <div className='col-12 '>
                              <table className='table sh_tablenew  sh_tablenew border-0 shadow-none  my-2 ' cellspacing='0' width="100%">
                                  <thead>
                                      <tr class="">
                                          <th class="sh_emrmotiontd"></th>
                                          <th class=" " style={{ 'vertical-align': 'middle' }}>Value </th>
                                          <th class="sh_emrmotiontd">Normal Range </th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {vitals.map((item, index) => {
                                          return (
                                              <tr className='border'>
                                                  <td className="sh_emrmotiontd">{item.label}</td>
                                                  <td className=" ">
                                                      <FormInputs {...item} className={`form-control ${getValidationClass(
                                                          formdata[item.name],
                                                          item.min_value,
                                                          item.max_value
                                                      )}`} value={formdata[item.name]} changeHandler={(val) => {handleChange(val,item.name) }} />
                                                  </td>
                                                  <td class="sh_emrmotiontd" style={{textTransform : 'none'}}>
                                                      <strong>{item.range}</strong>
                                                  </td>
                                              </tr>
                                          )
                                      })}
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>

              </div>
              <div class="card sh_basecard border-0 shadow-none h-auto">
                  <div class="card-header p-2 sh_basecardHeader">
                      <div class="d-flex w-100 justify-content-between align-items-center ">
                          Blood Pressure
                      </div>
                  </div>
                  <div class="card-body p-2 sh_basecardBody">
                      <div class="row">
                          <div class="col-12">
                              <table class="table sh_tablenew   my-2  " width="100%" cellspacing="0">
                                  <thead>
                                      <tr class="">
                                          <th class="w-25 sh_emrmotiontd"></th>
                                          <th class="w-25  " style={{ "vertical-align": "middle" }}>systolic </th>
                                          <th class="w-25  " style={{ "vertical-align": "middle" }}>Diastolic </th>
                                          <th class="w-25 sh_emrmotiontd">Normal Range</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr>
                                          <td className="sh_emrmotiontd">Blood Pressure</td>
                                          <td className=" ">
                                              <FormInputs {...bloodPressures[0]} value={formdata['left_bp']} className={`form-control ${getValidationClass(
                                                  formdata['left_bp'],
                                                  bloodPressures[0].min_value,
                                                  bloodPressures[0].max_value
                                              )}`} changeHandler={(val) => { handleChange(val, 'left_bp') }} />
                                          </td>
                                          <td className=" ">
                                              <FormInputs {...bloodPressures[1]} value={formdata['right_bp']}  className={`form-control ${getValidationClass(
                                                  formdata['right_bp'],
                                                  bloodPressures[1].min_value,
                                                  bloodPressures[1].max_value
                                              )}`}  changeHandler={(val) => {handleChange(val,'right_bp') }} />
                                          </td>
                                          <td class="sh_emrmotiontd" style={{textTransform : 'none'}}>
                                              <strong>Systolic: {bloodPressures[0].range}, Diastolic: {bloodPressures[1].range}</strong>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="sh_emrmotiontd">Blood Pressure Status</td>
                                          <td colSpan="2" className=" ">
                                              {(() => {
                                                  const status = calculateBloodPressureStatus(formdata['left_bp'], formdata['right_bp']);
                                                  const cssClasses = getCss('blood_pressure_result', status, 'LIGHT');
                                                  return (
                                                      <span className={`form-control ${cssClasses.appendClassName || ''}`} d-inline-block text-center p-2 border rounded>
                                                          {capitalizeName(status.toLowerCase())}
                                                      </span>
                                                  );
                                              })()}
                                          </td>
                                          <td class="sh_emrmotiontd"></td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="card h-auto sh_basecard border-0 shadow-none">
                  <div class="card-header p-2 sh_basecardHeader">
                      <div class="d-flex w-100 justify-content-between align-items-center ">
                          Vital History

                      </div>
                  </div>
                  <div class="card-body p-2 sh_basecardBody">
                      <TableGrid
                          hasPagination={true}
                          fetchTableRecords={(filters) =>
                              fetchHistory(filters)
                          }
                          {...tableRecords}
                      />
                     
                  </div>
              </div>

          </div>
{showUnsavedAlert && (
          <Alert
            contentTitle="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
            content="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
            yesButtonName="Discard"
            noButtonName="Cancel"
            type="warning"
            onDelete={handleProceed}   // Discard
            onClose={handleCancel}     // Cancel
            confirmButtonClassName="btn btn-danger"
            cancelButtonClassName="btn btn-secondary"
            saveAndClose={true} 
            onSaveAndClose={async () => { 
              // Call the main save function
              const success = await handleSubmit();
              if (success) {
                handleProceed(); // Navigate away if save was successful
              }
            }}
          />
        )}
    </div>
  )
}

export default WithRoutify(VitalsTab)